import Fuse from 'fuse.js';
import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';
import { v1 as uuidv1 } from 'uuid';

import { resetAbortController } from '../../../actions/utils';
import { useInfluencerSearchHistory } from '../../../hooks/useSearchHistory';
import { tipsService } from '../../../services';
import { InfluencerSuggestionItem } from '../../../shared/types';

// always render suggestion even if user only type 1 char
const shouldRenderSuggestions = () => true;

interface Props {
  value: string;
  onChange: (stockCode: string) => void;
  renderInputComponent: (props: any) => React.ReactNode;
  onKeyPress?: (e: any) => void;
}

const InfluencerInput: React.FC<Props> = ({
  value,
  onChange,
  renderInputComponent,
  onKeyPress,
}) => {
  const [suggestions, setSuggestions] = useState<InfluencerSuggestionItem[]>(
    []
  );
  const searchHistory = useInfluencerSearchHistory(value);

  const requestId = uuidv1();

  const onSuggestionsFetchRequested = ({ value }) => {
    const ac = resetAbortController(requestId);
    tipsService
      .searchInfluencer(ac.signal, value)
      .then(candidates => {
        // sort candidates in relevance order
        const options = {
          keys: ['name'],
        };

        const fuse = new Fuse(candidates, options);

        const result = fuse.search(value);
        setSuggestions(
          result
            .map((element: any) => {
              // on windows, element does not have item property, it is directly item itself
              if (element.item) return element.item;
              else if (element.name) return element;
              return null;
            })
            .filter(Boolean)
        );
      })
      .catch(() => setSuggestions([]));
  };

  const renderSuggestion = suggestion => {
    return <div>{suggestion.name}</div>;
  };

  const onSuggestionSelected = (_, { suggestionValue }) => {
    onChange(suggestionValue);
  };

  const onChangeInternal = (_, { newValue }) => {
    onChange(newValue);
  };

  return (
    <Autosuggest
      inputProps={{
        value,
        onChange: onChangeInternal,
        onKeyPress: onKeyPress,
      }}
      suggestions={value ? suggestions : searchHistory}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={() => setSuggestions([])}
      renderSuggestion={renderSuggestion}
      getSuggestionValue={suggestion => suggestion.name}
      onSuggestionSelected={onSuggestionSelected}
      renderInputComponent={renderInputComponent}
      shouldRenderSuggestions={shouldRenderSuggestions}
    />
  );
};

export default InfluencerInput;
